<template>
  <div class="relative">
    <video
      ref="vid"
      :thumbnail="thumbnail"
      autobuffer
      playsinline
      muted
      loop
      autoplay="autoplay"
      class="object-cover w-full"
    >
      <source :src="src">
      Your browser does not support our video.
    </video>
    <div v-if="hasSoundBoolean && !ended">
      <Transition>
        <button
          v-if="started"
          :class="`absolute p-2 ${btnPosition} opacity-70 hover:opacity-100 transition-opacity cursor-pointer`"
          :aria-label="muted ? 'Turn on sound' : 'Turn off sound'"
          @click.stop="toggleSound"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="w-6 h-6 text-white"
          >
            <!-- Speaker base (always shown) -->
            <path
              d="M13.5 4.06c0-1.336-1.616-2.005-2.56-1.06l-4.5 4.5H4.508c-1.141 0-2.318.664-2.66 1.905A9.76 9.76 0 001.5 12c0 .898.121 1.768.35 2.595.341 1.24 1.518 1.905 2.659 1.905h1.93l4.5 4.5c.945.945 2.561.276 2.561-1.06V4.06z"
            />
            <!-- Mute slash (muted) -->
            <path
              v-if="muted"
              d="M1.53 3.97a.75.75 0 011.06 0l18 18a.75.75 0 11-1.06 1.06l-18-18a.75.75 0 010-1.06z"
            />
          </svg>
        </button>
      </Transition>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    src: { type: String, required: true },
    btnPosition: { type: String, default: null },
    thumbnail: { type: String, default: null },
    hasSound: { type: Boolean, default: false },
  },
  data() {
    return { muted: true, started: false, ended: false, timer: null }
  },
  computed: {
    hasSoundBoolean() {
      // Handle boolean false, string "false", undefined, null, etc.
      return this.hasSound === true || this.hasSound === 'true'
    },
  },
  mounted() {
    const video = this.$refs.vid
    video.addEventListener('ended', () => {
      this.ended = true
    })
    setTimeout(() => {
      this.started = true
    }, 1000)
  },
  methods: {
    toggleSound() {
      if (this.hasSoundBoolean) {
        const video = this.$refs.vid
        this.muted = !this.muted
        video.muted = this.muted
      }
    },
  },
}
</script>

<style scoped>
.v-enter-active,
.v-leave-active {
  transition: opacity 1s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
